import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'math-pi', 'MathPi', [["path",{"d":"M7 20v-16"}],["path",{"d":"M17 4v16"}],["path",{"d":"M20 4h-16"}]]);